















import IconBase from "@/common/components/atoms/IconBase.vue";
import IconNoSearchResult158px from "@/common/components/icons/IconNoSearchResult158px.vue";
import IconNoSearchResult103px from "@/common/components/icons/IconNoSearchResult103px.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    IconBase,
    IconNoSearchResult158px,
    IconNoSearchResult103px
  }
})
export default class IconNoSearchResult extends Vue {
  @Prop({ type: Number, default: 158 }) iconSize!: number;
  @Prop({ type: String, default: "#ee1c25" }) iconColor!: string;

  iconHeight = {
    158: 163,
    103: 105
  };
}
